<template>
    <!-- 底部栏目 -->
    <div class="foot">
      <div class="footContainer">
       <div class="codeBox" v-for="(item,index) in list" :key="index">
        <div class="qrCode">
          <img :src="item.url" alt="二维码" style="width: 100%" />
        </div>
        <span style="font: 20px;color: #fff;margin-top: 10px;">{{item.name}}</span>
       </div>
      
        <div class="text">
          <span style="margin-bottom: 10px; font-weight: 400">联系我们：</span>
          <span style="margin-bottom: 20px; font-size: 50px; font-weight: 600"
            >400-88-1843</span
          >
          <span>地址：广东省深圳市南山区桃园路1号西海明珠大F栋23层</span>
        </div>
      </div>
      <div class="footText">
        <span>品谱宠物用品（深圳）有限公司 版权所有 2023-2025 <a href="http://beian.miit.gov.cn" target="_blank" style="color: #fff;">粤ICP备2023044087号</a></span>
      </div>
    </div>
</template>
<script>

export default {
    data() {
      return {
        list:[{
          url: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1747118633732118.jpg",
          name:'Tetra德彩微信公众号'
        },{
          url: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174711868107430.jpg",
          name:'Smartbones微信公众号'
        },{
          url: "https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/17471187054234.jpg",
          name:'富美内特微信公众号'
        }
      ]
      }
    },
}
</script>
<style lang="scss" scoped>

  .foot {
    width: 100%;
    height: 300px;
    background-color: #3f4552;
    .footContainer {
      width: 1200px;
      height: 80%;
      margin: 0 auto 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    .codeBox{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .qrCode {
        width: 140px;
        height: 140px;
        margin: 0 10px;
      }
    }
      .text {
        display: flex;
        flex-direction: column;
        margin-left: 20px;
        font-size: 20px;
        color: #fff;
      }
    }

    .footText {
      display: flex;
      justify-content: center;
      font-size: 16px;
      color: #a1a6b3;
    }
  }
    
</style>